// @ts-strict-ignore
import Link from 'next/link'
import { FC } from 'react'

import { Image } from '@/shared/ui/Image'

import cls from './index.module.scss'

type CategoryGridProps = {
	items?: {
		id?: string
		code?: string
		title?: string
		imgSrc: string
		link: string
	}[]
}

export const CategoryGrid: FC<CategoryGridProps> = ({ items }) => (
	<div className={cls.root}>
		{items.map(({ id, title, imgSrc, link }) => (
			<Link prefetch={false} href={link} key={id} className={cls.item}>
				<Image src={imgSrc} width={156} height={156} alt={title} />
				<p className={cls.item__title}>{title}</p>
			</Link>
		))}
	</div>
)
